// src/pages/mutuos/detalleMutuo/detalleMutuo.tsx (tu componente actual DetalleMutuo)
import React, { useEffect, useRef, useState } from 'react';
import ParticipantesForm from '../components/participantes/listaParticipantes';
import { useLocation, useNavigate } from 'react-router-dom';
import OperacionForm from '../components/operacion/operacionForm';
import GarantiaForm from '../components/garantias/garantiaForm';
import ResponsablesForm from '../components/responsables/responsablesForm';
import { useParticipantes } from '../hooks/useParticipantes';
import { OrigenDetalleMutuo, StatusCode, TipoFuncionalidad, TipoMutuo } from '../../../utils/enums';
import ValidacionesForm from '../components/validaciones/validacionesForm';
import Breadcrumb from '../../../components/ui/materialui/breadcrumb';
import { Card, CardContent, Grid2 } from '@mui/material';
import MButton from '../../../components/inputs/yup/materialui/mButton';
import CustomAccordion from '../../../components/ui/materialui/customAccordion';
import { useDetalleMutuo } from '../../../context/mutuoContext';
import DesactivarMutuo from '../components/desactivarMutuo/desactivarMutuo';
import DescargasForm from '../components/descargas/descargasForm';
import { IsDesactivado, isVigente } from '../services/servicesMutuo';
import { DetalleMutuoPermissionGuard } from '../../../components/auth/DetalleMutuoPermissionGuard';


interface Origen {
    labelBreadCrumb: string;
    urlBradCrumb: string;
}

const DetalleMutuo: React.FC = () => {
    const { obtenerMutuoComplementario, mutuoComple } = useParticipantes();
    const navigate = useNavigate();
    const location = useLocation();
    const { id: idEmergente } = location.state || {}
    const [origenRout, setOrigen] = useState<Origen>();
    const [idMutuo, setIdMutuo] = useState<number>(idEmergente);
    const { id, nombre, filtros, tipoMutuo, idSolicitud, origen, numeroOperacion } = useDetalleMutuo();
    const [isDesactivado, setIsDesactivado] = useState<boolean>(false);
    const [esVigente, setIsVigente] = useState<boolean | null>(null);

    const idSoli = parseInt(idSolicitud ?? '0');
    const esMutuoNormalyConComplementario = (tipoMutuo === TipoMutuo.Normal) && (mutuoComple?.mutuoIdComple != undefined && mutuoComple?.mutuoIdComple != undefined)
    const isComplementario: boolean = tipoMutuo === TipoMutuo.Complementario;
    const esVigenteOptional: boolean | undefined = esVigente ?? undefined;
    const esVigenteBoolean: boolean = esVigente ?? false;
    const participantesRef = useRef<HTMLInputElement | null>(null);

    const handleOrigen = () => {
        switch (origen) {
            case OrigenDetalleMutuo.BandejaMutuo:
                setOrigen({
                    labelBreadCrumb: 'Bandeja mutuos',
                    urlBradCrumb: '/bandeja-mutuos'
                });
                break;
            case OrigenDetalleMutuo.CarteraTotal:
                setOrigen({
                    labelBreadCrumb: 'Cartera total',
                    urlBradCrumb: '/cartera-mutuos'
                });
                break;
            default:
                break;
        }
    }

    const EsDesactivado = async (mutuoId: number) => {
        const resp = await IsDesactivado(mutuoId);
        if (resp.status === StatusCode.Ok) {
            setIsDesactivado(resp.data.valor);
        }
    }

    const EsVigente = async (mutuoId: number) => {
        const resp = await isVigente(mutuoId);
        if (resp.status === StatusCode.Ok) {
            setIsVigente(resp.data.valor)
        }
    }

    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: origenRout?.labelBreadCrumb ?? '', url: origenRout?.urlBradCrumb ?? '', state: filtros },
        { label: 'Detalle mutuo', active: true },
        { label: `${origen === OrigenDetalleMutuo.BandejaMutuo ? idSolicitud : numeroOperacion} - ${tipoMutuo ?? ""} - ${nombre ?? ''}`, active: true },
    ]

    useEffect(() => {
        if (id) {
            setIdMutuo(parseInt(id ?? '0'));
        }
    }, [id])

    useEffect(() => {
        if (idSoli) {
            obtenerMutuoComplementario(idSoli);
        }
    }, [idMutuo, idSoli])

    useEffect(() => {
        if (idMutuo)
            handleOrigen();
    }, [idMutuo, origen])

    useEffect(() => {
        EsDesactivado(idMutuo);
        EsVigente(idMutuo);
    }, [idMutuo]);

    const handleCambioMutuo = async () => {
        if (tipoMutuo === TipoMutuo.Normal) {
            navigate(`/mutuos`, { state: { nombre: nombre, idSolicitud: idSolicitud, filtros: filtros, tipoMutuo: TipoMutuo.Complementario, origen: origenRout, id: mutuoComple?.mutuoIdComple } })
        } else {
            navigate(`/mutuos`, { state: { nombre: nombre, idSolicitud: idSolicitud, filtros: filtros, tipoMutuo: TipoMutuo.Normal, origen: origenRout, id: mutuoComple?.mutuoIdNormal } })
        }
    }

    const [showDesactivate, setShowDesactivar] = useState<boolean>(false);

    const handleDesactivarMutuoClick = () => {
        setShowDesactivar(true);
    }

    const handleCloseDesactivarMutuo = () => {
        setShowDesactivar(false);
    }

    return (
        <>
            {showDesactivate ? (
                <DesactivarMutuo
                    idMutuo={idMutuo}
                    onVolver={handleCloseDesactivarMutuo}
                />
            ) : (
                <DetalleMutuoPermissionGuard
                    esVigente={esVigenteOptional}
                    permissions={[TipoFuncionalidad.Bandeja_ver, TipoFuncionalidad.Cartera_ver]}
                    fallback={<div>No tienes permisos para ver el mutuo.</div>}
                >
                    <Grid2 container spacing={2} sx={{ mb: 2 }}>
                        <Grid2 size={{ xs: 12, lg: 8 }}>
                            <Breadcrumb items={breadcrumbItems} />
                        </Grid2>

                        {(mutuoComple?.mutuoIdComple) && (
                            <Grid2 size={{ xs: 12, lg: 4 }} display="flex" justifyContent="flex-end" mb={3} mt={0}>
                                <MButton
                                    variant='contained'
                                    color='primary'
                                    onClick={() => handleCambioMutuo()}
                                >
                                    Ver {tipoMutuo === TipoMutuo.Normal ? 'mutuo complementario' : 'mutuo normal'}
                                </MButton>
                            </Grid2>
                        )}
                    </Grid2>
                    <Card sx={{ mb: 2, backgroundcolor: 'white' }} raised>
                        <CardContent>
                            <DetalleMutuoPermissionGuard
                                esVigente={esVigenteOptional}
                                permissions={[TipoFuncionalidad.Bandeja_ver, TipoFuncionalidad.Cartera_ver]}>
                                <CustomAccordion
                                    title="Responsables"
                                    expandedDefault={false}
                                >
                                    <ResponsablesForm
                                        idMutuo={idMutuo}
                                        esMutuoNormalyConComplementario={esMutuoNormalyConComplementario}
                                        isComplementario={isComplementario}
                                        idSolicitud={idSolicitud}
                                        isDesactivado={isDesactivado}
                                        esVigente={esVigenteOptional}
                                    />
                                </CustomAccordion>
                            </DetalleMutuoPermissionGuard>

                            <DetalleMutuoPermissionGuard
                                esVigente={esVigenteOptional}
                                permissions={[TipoFuncionalidad.Bandeja_ver, TipoFuncionalidad.Cartera_ver]}>

                                <CustomAccordion
                                    title='Participantes'
                                    expandedDefault={false}
                                >
                                    <ParticipantesForm idMutuo={idMutuo} participantesRef={participantesRef}
                                        esMutuoNormalyConComplementario={esMutuoNormalyConComplementario} isComplementario={isComplementario}
                                        idSolicitud={idSolicitud} isDesactivado={isDesactivado} esVigente={esVigenteOptional}></ParticipantesForm>
                                </CustomAccordion>
                            </DetalleMutuoPermissionGuard>

                            <DetalleMutuoPermissionGuard
                                esVigente={esVigenteOptional}
                                permissions={[TipoFuncionalidad.Bandeja_ver, TipoFuncionalidad.Cartera_ver]}>                                <CustomAccordion
                                    title='Operación'
                                    expandedDefault={false}
                                >
                                    <OperacionForm idMutuo={idMutuo} esMutuoNormalyConComplementario={esMutuoNormalyConComplementario}
                                        isComplementario={isComplementario} idSolicitud={idSolicitud} isDesactivado={isDesactivado} esVigente={esVigenteOptional}></OperacionForm>
                                </CustomAccordion>
                            </DetalleMutuoPermissionGuard>

                            <DetalleMutuoPermissionGuard
                                esVigente={esVigenteOptional}
                                permissions={[TipoFuncionalidad.Bandeja_ver, TipoFuncionalidad.Cartera_ver]}>
                                <CustomAccordion
                                    title='Garantías'
                                    expandedDefault={false}
                                >
                                    <GarantiaForm idMutuo={idMutuo} isComplementario={isComplementario} idSolicitud={idSolicitud} isDesactivado={isDesactivado} esVigente={esVigenteOptional}></GarantiaForm>
                                </CustomAccordion>
                            </DetalleMutuoPermissionGuard>

                            <DetalleMutuoPermissionGuard
                                esVigente={esVigenteOptional}
                                permissions={[TipoFuncionalidad.Bandeja_ver, TipoFuncionalidad.Cartera_ver]}>
                                <CustomAccordion
                                    title='Validaciones'
                                    expandedDefault={false}
                                >
                                    <ValidacionesForm
                                        mutuoId={idMutuo}
                                        filtros={filtros}
                                        onDesactivarClick={handleDesactivarMutuoClick}
                                        isDesactivado={isDesactivado}
                                        esVigente={esVigenteBoolean}
                                    />
                                </CustomAccordion>
                            </DetalleMutuoPermissionGuard>

                            <DetalleMutuoPermissionGuard
                                esVigente={esVigenteOptional}
                                permissions={[TipoFuncionalidad.Bandeja_ver, TipoFuncionalidad.Cartera_ver]}>
                                <CustomAccordion
                                    title='Descargas'
                                    expandedDefault={false}
                                >
                                    <DescargasForm
                                        mutuoId={idMutuo}
                                    />
                                </CustomAccordion>
                            </DetalleMutuoPermissionGuard>
                        </CardContent>
                    </Card>
                </DetalleMutuoPermissionGuard>
            )}
        </>
    )
}

export default DetalleMutuo;